import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AttachmentService } from 'src/sb-tools/typescript/services/attachment.service';
import { environment } from '@environment';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-attachments-modal',
    templateUrl: './attachments-modal.component.html',
    styleUrls: ['./attachments-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DropzoneModule, TranslateModule],
})
export class AttachmentsModalComponent implements OnInit, OnDestroy {
    acceptedFiles?;
    config;
    modalId? = null; // if modal is nested, need to pass id to close particular this modal
    existedAttachmentsLength: number;
    files = [];
    isSubreply?;
    item;
    maxFilesize?;
    newAttachments;
    uploadMultiple?;
    isUploadingFiles: boolean;

    private unsubscriber = new Subject<void>();

    constructor(
        public attachmentService: AttachmentService,
        private modalRef: BsModalRef,
        private modalService: BsModalService,
    ) {}

    ngOnInit() {
        this.config = this.attachmentService.getDropzoneConfig(
            environment.uploadsUrl + 'ticketAttachments/',
            this.maxFilesize ? this.maxFilesize : 25,
            this.uploadMultiple,
            this.acceptedFiles,
            this.existedAttachmentsLength,
        );

        this.attachmentService.isUploadingFilesFinished.pipe(takeUntil(this.unsubscriber)).subscribe((isFinished) => {
            this.isUploadingFiles = !isFinished;
        });
    }

    addAttachments() {
        Array.prototype.push.apply(this.newAttachments, this.files);

        this.close();
    }

    close(): void {
        if (this.modalId) {
            this.modalService.hide(this.modalId);
        } else {
            this.modalRef.hide();
        }
    }

    onFinishUploading() {
        this.attachmentService.changeUploadingStatus(true);
    }

    onProcessUploading() {
        this.attachmentService.changeUploadingStatus(false);
    }

    onRemovedFile(file) {
        if (file.xhr) {
            const parsedFileUrl = JSON.parse(file.xhr.response).url;
            const fileIndex = this.files.findIndex((item) => {
                return item.url === parsedFileUrl;
            });

            if (fileIndex === -1) {
                return;
            }
            this.files.splice(fileIndex, 1);

            this.attachmentService.deleteFile(parsedFileUrl);
        }
    }

    onUploadSuccess(event) {
        this.files.push(event[1]);
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
